<template>
  <div class="has-text-centered">
    <font-awesome-icon
      icon="atom"
      spin
      :size="size"
    />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '2x'
    }
  }
}
</script>
